import React from 'react';
import PropTypes from 'prop-types';

const PopUpButton = props => {
  const { icon, popupName, text, wardrobesConfigs, propClass, iconClass } = props;
  let isHinged;
  if (wardrobesConfigs !== undefined) {
    isHinged = wardrobesConfigs.is_hinged;
  }

  const openPopup = () => {
    const popup = document.querySelector(`[data-popup-name="${popupName}"]`);
    if (!!popup) {
      popup.classList.add('open');
    }
  };

  return (
    <>
      {text ? (
        <button
          className={`pop-up__button pop-up__button--margin ${propClass ? propClass : null}`}
          onClick={openPopup}>
          <span className={`icon-${icon} ${iconClass ? iconClass : null} `} />
          <span className="info-text">{text}</span>
        </button>
      ) : isHinged !== undefined ? (
        <div className="icon--position">
          <p>{isHinged ? 'Drzwi Uchylne' : 'Drzwi Przesuwne'}</p>
          <button
            className={`pop-up__button pop-up__button--margin ${propClass ? propClass : null}`}
            onClick={openPopup}>
            <span className={`icon-${icon} ${iconClass ? iconClass : null}`} />
          </button>
        </div>
      ) : (
        <button
          className={`pop-up__button pop-up__button--margin ${propClass ? propClass : null}`}
          onClick={openPopup}>
          <span className={`icon-${icon} ${iconClass ? iconClass : null}`} />
        </button>
      )}
    </>
  );
};

PopUpButton.propTypes = {
  icon: PropTypes.string,
  popupName: PropTypes.string.isRequired,
  text: PropTypes.string,
  propClass: PropTypes.string,
};

export default PopUpButton;
